export default checkboxes => {
    if ($('input[type=checkbox].toggle').length < 1) {
        return false;
    }

    let $checkboxes = $('input[type=checkbox].toggle');

    $checkboxes.each((index, item) => {
        let $item = $(item);

        $('<span class="checkbox"></span>').insertAfter($item);
    });

    let $checkboxFake = $('span.checkbox');

    $checkboxFake.on('click', event => {
        let $checkbox = $(event.currentTarget);
        let $input = $checkbox.prev();

        if ($input.is(':checked')) {
            $input.removeAttr('checked');
        } else {
            $input.prop('checked', 'checked');
        }

        return $input.trigger('change');
    });
};